/* eslint-disable  no-unused-vars, max-len, quotes, key-spacing, comma-spacing */
// Dependencies'
import React, {useState, useEffect} from 'react'
import {connect} from 'react-redux'
// import {Route} from 'react-router-dom'
import Helpers from '../Helpers.js'

// Actions
import {storePayload} from '../actions/storePayload.js'

// Components
import {Notification, Icon, Modal} from '@lazarusai/forms-ui-components'
import ResourcesModal from './ResourcesModal.js'
import ReferencesModal from './ReferencesModal.js'
// import FullLoadingScreen from './FullLoadingScreen.js'
import PathSelectPage from './PathSelectPage.js'
// import Prompt from './Prompt.js'
import Workflow from './Workflow.js'
// import AcquisPathSelect from './AcquisPathSelect.js'
import FileUploadContainer from './FileUploadContainer.js'
import SectionSelectPage from './SectionSelectPage.js'
import Splash from './Splash.js'
import Resources from './Resources.js'
import AlfLoading from './AlfLoading.js'
import AcquisPath from './AcquisPath.js'
// import PathButton from './PathButton'

// Styles
import '@lazarusai/forms-ui-components/dist/index.css'
import '../styles/App.css'

function App(props) {
  const [isNotificationVisible, setIsNotificationVisible] = useState(true)

  /* animates notification */
  const onClickNotification = () => {
    setIsNotificationVisible(false)
    setTimeout(() => {
      props.storePayload({
        userMessage: null,
        notificationType: null,
        notificationIcon: null,
      })
      setIsNotificationVisible(true)
    }, 300)
  }

  function closeModals() {
    props.storePayload({
      isReferencesModalShowing: false,
      isResourcesModalShowing: false,
    })
  }

  /* Show Welcome message on component mount */

  // function onClickPathButton() {
  //   console.log('store payload', props.storePayload)
  //   props.storePayload({
  //     isAcquiPathSelect: true,
  //     isAcquiPathSelectShowing: true,
  //   })
  // }

  // useEffect(() => {
  //   const testJSON = {
  //     "chat": [
  //       {"role": "user", "content": "Context: The user is currently on the 'executive summary' page of the capability and needs statement. Your job is to assist them with answering any questions that they might have."},
  //       {"role": "assistant", "content": "Understood! How can I help?"},
  //       {"role": "user", "content": "Who is this executive summary mean for?"}
  //     ],
  //   }
  //   const crashJSON = {"chat":[{"content":"Context: The user is currently on the Resourcing and schedule page of the capability and needs statement. Your job is to assist them with answering any questions that they might have.","role":"user"},{"content":"Understood! How can I help?","role":"assistant"},{"content":"I'm testing how many questions you can handle.","role":"user"},{"content":"I can handle multiple questions as long as they are related to the topic of the capability and needs statement or any other relevant subject matter. Please feel free to ask any questions you have, and I'll do my best to provide accurate and helpful information.","role":"assistant"},{"content":"What section of the capability needs statement are we on?","role":"user"},{"content":"We are currently on the Resourcing and Schedule section of the capability needs statement. This part focuses on identifying the resources required to implement the capability, as well as outlining the timeline and milestones for its development and deployment.","role":"assistant"},{"content":"Will you crash after this question?","role":"user"},{"content":"No, I won't crash after this question. I am an AI designed to handle multiple questions and provide assistance on various topics. If you have any more questions or need help with something else, feel free to ask.","role":"assistant"},{"content":"I think you might crash soon.","role":"user"},{"content":"I assure you, I am not going to crash. I am an AI built to handle multiple questions and provide assistance on various topics. If you have any more questions or need help with something else, feel free to ask.","role":"assistant"},{"role":"user","content":"What about now?"}]}
  //   console.log(crashJSON, testJSON)
  //   Helpers.fetchPostJson(
  //       process.env.REACT_APP_CHATURL,
  //       testJSON,
  //       {authKey: process.env.REACT_APP_AUTHKEY},
  //   )
  //       .then(console.log)
  //       .catch(console.error)
  // }, [])

  /* Automatically close type 2 notifications */
  useEffect(() => {
    if (props.notificationType === 2) {
      setTimeout(onClickNotification, 7000)
    }
  }, [props.notificationType])


  useEffect(() => {
    if (props.savesProgress) {
      let jsonRes
      let jsonRes2
      if (props.prompt1Response) {
        jsonRes = JSON.stringify(props.prompt1Response)
        localStorage.setItem('dataInProgress', jsonRes)
        localStorage.setItem('dataSavedAt', Date.now())
        console.log('saving...')
      }
      if (props.localPrompt1Response) {
        jsonRes2 = JSON.stringify(props.localPrompt1Response)
        localStorage.setItem('localDataInProgress', jsonRes2)
        localStorage.setItem('dataSavedAt', Date.now())
        console.log('saving...')
      }
      // To do save state of app (current indices)
    }
  }, [props.time])

  const render = {
    'splash': <Splash />,
    'middle-tier': <AcquisPath path={'Middle Tier of Acquisition'}/>,
    'file-upload': <FileUploadContainer />,
    'path-select': <PathSelectPage />,
    'section-select': <SectionSelectPage />,
    'type-form': <Workflow />,
    'resources': <Resources />,
  }

  return (
    <>
      {props.isLoading && <AlfLoading />}
      {props.isResourcesModal &&
        <ResourcesModal
          headerText={'Resources & Support'}
          // eslint-disable-next-line max-len
          subheaderText={'These resources may aid your technical strategies:'}
          isVisible={props.isResourcesModalShowing}
          refData={props.resources}
          onCancel={closeModals}
          theme={props.theme}
        />
      }
      {props.isReferencesModal && props.references &&
        <ReferencesModal
          headerText={'References'}
          // eslint-disable-next-line max-len
          subheaderText={'These technical organizations may aid your technical strategies:'}
          isVisible={props.isReferencesModalShowing}
          refData={props.references}
          onCancel={closeModals}
          theme={props.theme}
        />
      }
      {props.userMessage &&
        <Notification
          type={props.notificationType || 1}
          icon={(
            <div
              className={
                `toggle-container
                ${props.notificationIcon === 'check' ? 'toggled' : ''}`
              }
            >
              <Icon
                fill='var(--colors-brand-state-success-contrast-dark)'
                icon='checkmark-outline'
              />
              <Icon
                fill='var(--colors-brand-state-warn-contrast-dark)'
                icon='alert-circle-outline'
              />
            </div>
          )}
          content={props.userMessage}
          time={Helpers.timeStampToTime(Date.now())}
          isVisible={isNotificationVisible}
          onClick={onClickNotification}
          showBackdrop={props.notificationType === 3 ? true : false}
          theme='dark'
        />
      }
      <div className='app'>
        {render[props.step]}
      </div>
    </>
  )
}

const mapStateToProps = (state, ownProps) => ({
  cookies: ownProps.cookies,
  userMessage: state.userReducer.userMessage,
  notificationType: state.userReducer.notificationType,
  notificationIcon: state.userReducer.notificationIcon,
  prompt1Response: state.userReducer.prompt1Response,
  localPrompt1Response: state.userReducer.localPrompt1Response,
  isLoading: state.userReducer.isLoading,
  selectedPath: state.userReducer.selectedPath,
  theme: state.userReducer.theme,
  step: state.userReducer.step,
  time: state.userReducer.time,
  savesProgress: state.userReducer.savesProgress,
  isLocalStorageModal: state.userReducer.isLocalStorageModal,
  isLocalStorageModalShowing: state.userReducer.isLocalStorageModalShowing,
  dataSavedAt: state.userReducer.dataSavedAt,
  dataInProgress: state.userReducer.dataInProgress,
  localDataInProgress: state.userReducer.localDataInProgress,
  isResourcesModal: state.userReducer.isResourcesModal,
  isResourcesModalShowing: state.userReducer.isResourcesModalShowing,
  isReferencesModal: state.userReducer.isReferencesModal,
  isReferencesModalShowing: state.userReducer.isReferencesModalShowing,
  references: state.userReducer.references,
})

export default connect(
    mapStateToProps,
    {storePayload},
)(App)

